import { render, staticRenderFns } from "./RolePermissionExplorer.vue?vue&type=template&id=5fd3ec0e&scoped=true"
import script from "./RolePermissionExplorer.vue?vue&type=script&lang=js"
export * from "./RolePermissionExplorer.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionExplorer.vue?vue&type=style&index=0&id=5fd3ec0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd3ec0e",
  null
  
)

export default component.exports